export interface ChartDataPoint {
  date: string // ISO date string (YYYY-MM-DD) for unique X-axis positioning
  dateLabel?: string // Formatted label for display (e.g., "Nov 17")
  fullDate: Date
  timestamp: number // Numeric timestamp for proper sorting/positioning
  callsHandledByAI: number
  callsOutbound: number
  callsResolved: number
  smsHandledByAI: number
  smsResolved: number
}

export function generateChartData(dateRange: string): ChartDataPoint[] {
  const endDate = new Date()
  const startDate = new Date()
  let days

  switch (dateRange) {
    case '7d':
      days = 7
      startDate.setDate(endDate.getDate() - 7)
      break
    case '30d':
      days = 30
      startDate.setDate(endDate.getDate() - 30)
      break
    case '90d':
      days = 90
      startDate.setDate(endDate.getDate() - 90)
      break
    default:
      days = 30
      startDate.setDate(endDate.getDate() - 30)
      break
  }

  const data: ChartDataPoint[] = []
  for (let i = 0; i < days; i++) {
    const currentDate = new Date(startDate)
    currentDate.setDate(startDate.getDate() + i)

    let dateLabel = ''
    if (days <= 7) {
      const month = currentDate.toLocaleDateString('en-US', { month: 'short' })
      const day = currentDate.getDate()
      dateLabel = `${month} ${day}`
    } else if (days <= 30) {
      if (i % 5 === 0 || i === days - 1) {
        const month = currentDate.toLocaleDateString('en-US', {
          month: 'short',
        })
        const day = currentDate.getDate()
        dateLabel = `${month} ${day}`
      } else {
        dateLabel = ''
      }
    } else {
      if (i % 7 === 0 || i === days - 1) {
        const month = currentDate.toLocaleDateString('en-US', {
          month: 'short',
        })
        const day = currentDate.getDate()
        dateLabel = `${month} ${day}`
      } else {
        dateLabel = ''
      }
    }

    const isoDate = currentDate.toISOString().split('T')[0]

    data.push({
      date: isoDate, // Use ISO date for unique X-axis positioning
      dateLabel: dateLabel, // Store formatted label for display
      fullDate: currentDate,
      timestamp: currentDate.getTime(), // Numeric timestamp for proper sorting/positioning
      callsHandledByAI: 0,
      callsOutbound: 0,
      callsResolved: 0,
      smsHandledByAI: 0,
      smsResolved: 0,
    })
  }

  return data
}
